import "normalize.css/normalize.css";
import React from "react";
import { Route, Switch } from "react-router-dom";
import { EditPageContainer } from "../EditPage";
import { indexRoutes } from "../IndexPage";
import { NewPageContainer } from "../NewPage";
import { VotePageRouterContainer } from "../RolloutContest/VotePage/VotePageRouter";
import { RolloutConfirmedPageContainer, RolloutLandingPageContainer } from "../RolloutLandingPage";
import { ShowPageContainer } from "../ShowPage";

export const routes = ({ match: { path } }) => (
  <Switch>
    {indexRoutes(path)}
    <Route path={`${path}/vote`} component={VotePageRouterContainer} />
    <Route path={`${path}/rollout`} component={RolloutLandingPageContainer} />
    <Route path={`${path}/rollout/:page`} component={RolloutLandingPageContainer} />
    <Route path={`${path}/rollout_confirmed`} component={RolloutConfirmedPageContainer} />
    <Route path={`${path}/new`} component={NewPageContainer} />
    <Route path={`${path}/:slug`} exact component={ShowPageContainer} />
    <Route path={`${path}/:slug/edit`} component={EditPageContainer} />
  </Switch>
);
